import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * Removes static meta tags from index.html that will be replaced by this
 * component, avoiding duplicates that would otherwise confuse crawlers.
 */
const OVERRIDABLE = [
  { selector: "title:not([data-rh-managed])" },
  { selector: "link[rel='canonical']:not([data-rh-managed])" },
  { selector: "meta[name='description']:not([data-rh-managed])" },
  { selector: "meta[property='og:type']:not([data-rh-managed])" },
  { selector: "meta[property='og:title']:not([data-rh-managed])" },
  { selector: "meta[property='og:description']:not([data-rh-managed])" },
  { selector: "meta[property='og:url']:not([data-rh-managed])" },
  { selector: "meta[property='og:image']:not([data-rh-managed])" },
  { selector: "meta[name='twitter:card']:not([data-rh-managed])" },
  { selector: "meta[name='twitter:title']:not([data-rh-managed])" },
  { selector: "meta[name='twitter:description']:not([data-rh-managed])" },
  { selector: "meta[name='twitter:image']:not([data-rh-managed])" },
];

export default function SEO({ title, description, path = "/", image }) {
  const url = `https://licito.guru${path}`;
  const ogImage = image || "https://licito.guru/og-image.png";

  useEffect(() => {
    OVERRIDABLE.forEach(({ selector }) => {
      document.querySelectorAll(selector).forEach((el) => el.remove());
    });
  }, []);

  return (
    <Helmet>
      <title data-rh-managed>{title}</title>
      <meta data-rh-managed name="description" content={description} />
      <link data-rh-managed rel="canonical" href={url} />

      <meta data-rh-managed property="og:type" content="website" />
      <meta data-rh-managed property="og:url" content={url} />
      <meta data-rh-managed property="og:title" content={title} />
      <meta data-rh-managed property="og:description" content={description} />
      <meta data-rh-managed property="og:image" content={ogImage} />

      <meta data-rh-managed name="twitter:card" content="summary_large_image" />
      <meta data-rh-managed name="twitter:title" content={title} />
      <meta data-rh-managed name="twitter:description" content={description} />
      <meta data-rh-managed name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
